// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class HhsAttestations {
    static getAttributeTypeMap() {
        return HhsAttestations.attributeTypeMap;
    }
}
HhsAttestations.discriminator = undefined;
HhsAttestations.additionalProperties = false;
HhsAttestations.attributeTypeMap = [
    {
        "name": "correspondenceOptOut",
        "baseName": "correspondenceOptOut",
        "type": "boolean"
    },
    {
        "name": "patientInsured",
        "baseName": "patientInsured",
        "type": "boolean"
    },
    {
        "name": "patientHasSecondaryCoverage",
        "baseName": "patientHasSecondaryCoverage",
        "type": "boolean"
    },
    {
        "name": "signersFullName",
        "baseName": "signersFullName",
        "type": "string"
    },
    {
        "name": "providerWitnessedSignature",
        "baseName": "providerWitnessedSignature",
        "type": "boolean"
    },
    {
        "name": "providerInitials",
        "baseName": "providerInitials",
        "type": "string"
    },
    {
        "name": "policyHolderName",
        "baseName": "policyHolderName",
        "type": "string"
    },
    {
        "name": "consentAuthorizedBy",
        "baseName": "consentAuthorizedBy",
        "type": "HhsAuthorizedBy"
    },
    {
        "name": "authorizorRelationshipToPatient",
        "baseName": "authorizorRelationshipToPatient",
        "type": "string"
    },
    {
        "name": "hipaaConsentAttestation",
        "baseName": "hipaaConsentAttestation",
        "type": "boolean"
    },
    {
        "name": "textMessageOptIn",
        "baseName": "textMessageOptIn",
        "type": "boolean"
    },
    {
        "name": "physicalCardOptOut",
        "baseName": "physicalCardOptOut",
        "type": "boolean"
    },
    {
        "name": "applicantDeclarationsAttestation",
        "baseName": "applicantDeclarationsAttestation",
        "type": "boolean"
    },
    {
        "name": "providerCertifiedNecessity",
        "baseName": "providerCertifiedNecessity",
        "type": "boolean"
    },
    {
        "name": "patientEligible",
        "baseName": "patientEligible",
        "type": "boolean"
    },
    {
        "name": "patientNotEligibleReason",
        "baseName": "patientNotEligibleReason",
        "type": "string"
    },
];
//# sourceMappingURL=hhsAttestations.js.map